import React, { useState, useEffect } from "react";
import { Nav, Navbar, Container, NavDropdown } from "react-bootstrap";
import styles from "./NavbarMain.module.css";
import { NavLink } from "react-router-dom";
import { Link } from 'react-router-dom';
import logo2 from '../../assets/home/LogoMain.PNG'
const CustomToggle = ({ onClick }) => (
  <button className={styles.customToggle} onClick={onClick}>
    <span className={styles.toggleIcon}></span>
    <span className={styles.toggleIcon}></span>
    <span className={styles.toggleIcon}></span>
  </button>
);
const NavbarMain = () => {

  const [show, setShow] = useState(false);
  const [activeNav, setActiveNav] = useState([true, false, false, false]);
  const [expand, setExpand] = useState(false);

  const closeNav = () => {
    setExpand(false);
  }

  const showDropdown = (e) => {
    setShow(!show);
  };
  const hideDropdown = (e) => {
    setShow(false);
  };

  useEffect(() => {
    if (sessionStorage.getItem("NavbarMain") != null) {
      let temp = JSON.parse(sessionStorage.getItem("NavbarMain"));
      setActiveNav([...temp]);
    }
  }, []);

  const handleActiveNav = (i) => {
    let temp = activeNav;
    temp = temp.map((x) => (x = false));
    temp[i] = true;
    setActiveNav([...temp]);
    sessionStorage.setItem("NavbarMain", JSON.stringify(temp));

  };
  return (
    <>
      <Navbar
        style={{
          backgroundColor: "#011126",
          boxShadow: "1px 1px 10px rgb(0 0 0 / 0.4)",
          padding: "3px"
        }}
        variant="light"
        expand="lg"
        sticky="top"
        onToggle={() => { setExpand(prevState => !prevState) }}
        expanded={expand}
      >
        <Container>
          <Navbar.Brand href="/" >
            {/* Cyber<span style={{ color: "white" }}>TechGate</span> */}
            <img src={logo2} className={styles.logo} alt="Logo" />
          </Navbar.Brand>
          {/* <Navbar.Toggle aria-controls="basic-navbar-nav" /> */}
          <CustomToggle onClick={() => setExpand(!expand)} />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav style={{ marginLeft: 'auto' }} >
              <NavLink
                to="/"
                className={`${styles.nav_text} nav-link ${activeNav[0] ? styles.active : ""}`}
                style={{ marginTop: "8px" }}
                onClick={() => { handleActiveNav(0); closeNav() }}
              >
                Home
              </NavLink>
              <NavLink
                to="/aboutUs"
                className={`${styles.nav_text} nav-link ${activeNav[1] ? styles.active : ""}`}
                style={{ marginTop: "8px" }}
                onClick={() => { handleActiveNav(1); closeNav() }}
              >
                About us
              </NavLink>
              <NavDropdown
                show={show}
                onMouseEnter={showDropdown}
                onMouseLeave={hideDropdown}
                className={`nav-link ${styles.drop}`}
                title={
                  <Link to="/services" style={{ textDecoration: 'none' }} className={styles.dropicon} onClick={() => { handleActiveNav(2); closeNav() }}>
                    <span className={`${styles.nav_text} my-auto ${activeNav[2] ? styles.active : ""}`}>
                      Services
                    </span>
                  </Link>
                }
                id="basic-nav-dropdown"
              >
                <NavDropdown.Item className={styles.dropdownItem}><NavLink to="/individualService?id=1" onClick={() => { handleActiveNav(2); closeNav() }} className={styles.dropdownText}>IT Security Audit</NavLink></NavDropdown.Item>
                <NavDropdown.Item className={styles.dropdownItem}><NavLink to="/individualService?id=2" onClick={() => { handleActiveNav(2); closeNav() }} className={styles.dropdownText}>IT Policy System</NavLink></NavDropdown.Item>
                <NavDropdown.Item className={styles.dropdownItem}><NavLink to="/individualService?id=3" onClick={() => { handleActiveNav(2); closeNav() }} className={styles.dropdownText}>Incident Response</NavLink></NavDropdown.Item>
                <NavDropdown.Item className={styles.dropdownItem}><NavLink to="/individualService?id=4" onClick={() => { handleActiveNav(2); closeNav() }} className={styles.dropdownText}>Cloud Security</NavLink></NavDropdown.Item>
                <NavDropdown.Item className={styles.dropdownItem}><NavLink to="/individualService?id=5" onClick={() => { handleActiveNav(2); closeNav() }} className={styles.dropdownText}>Penetration Testing</NavLink></NavDropdown.Item>
                <NavDropdown.Item className={styles.dropdownItem}><NavLink to="/individualService?id=6" onClick={() => { handleActiveNav(2); closeNav() }} className={styles.dropdownText}>Cyber Scurity Consultancy</NavLink></NavDropdown.Item>

              </NavDropdown>
              <NavLink
                to="/contactUs"
                className={` ${styles.nav_text} nav-link ${activeNav[3] ? styles.active : ""}`}
                style={{ marginTop: "8px" }}
                onClick={() => { handleActiveNav(3); closeNav() }}
              >
                Contact Us
              </NavLink>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <style jsx="true">
        {`
         .dropdown-menu{
          background-color: #053c84 !important;
         }
        `}
      </style>
    </>
  );
};

export default NavbarMain;
